import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TaxCalculator from './components/TaxCalculator';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import About from './pages/About';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import BlogIndex from './pages/blog/BlogIndex';
import UKTaxCalculatorGuide from './pages/blog/UKTaxCalculatorGuide';
import UKTaxBandsGuide from './pages/blog/UKTaxBandsGuide';
import Tax30kGuide from './pages/blog/Tax30kGuide';
import BillionaireTaxSavings from './pages/blog/BillionaireTaxSavings';
import BrexitCostTaxSavings from './pages/blog/BrexitCostTaxSavings';
import AlternativeTaxSources from './pages/blog/AlternativeTaxSources';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<TaxCalculator />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/uk-tax-calculator-guide" element={<UKTaxCalculatorGuide />} />
          <Route path="/blog/uk-tax-bands-guide" element={<UKTaxBandsGuide />} />
          <Route path="/blog/tax-on-30k-salary" element={<Tax30kGuide />} />
          <Route path="/blog/billionaire-tax-savings" element={<BillionaireTaxSavings />} />
          <Route path="/blog/brexit-cost-savings" element={<BrexitCostTaxSavings />} />
          <Route path="/blog/alternative-tax-sources" element={<AlternativeTaxSources />} />
        </Routes>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
